<template>
    <div class="androidApplicationClass">
      <div>
        <HeaderView />
      </div>
      <div>
        <AndroidA />
      </div>
      <div>
        <FooterView />
      </div>
    </div>
    </template>
    
    <script>
    import HeaderView from "@/components/HeaderView.vue";
    import FooterView from "@/components/FooterView.vue";
    import AndroidA from "@/components/ServicePages/MobileApplicationPage/AndroidPage/AndroidA.vue";
    
    export default {
      name: "ColorRain",
      components: {
        HeaderView,
        AndroidA,
        FooterView,
      },
    };
    </script>
    
    <style scoped>
    
    </style>
      